
import { mixins, Options } from 'vue-class-component';
import { formatMoney } from '@/api/shopify/formatMoney';
import ShopifyClient from '@/api/shopify/shopify';
import LazyImage from '@/components/LazyImage.vue';
import MTokenCartDelete from '@/components/shopify/MTokenCartDelete.vue';
import CheckoutWidgetMixin from '@/mixins/checkoutWidget';

@Options({
  components: {
    LazyImage,
    MTokenCartDelete
  }
})
export default class MTokenCartItem extends mixins(CheckoutWidgetMixin) {
  shopifyClient = new ShopifyClient();

  product: {
    featured_image: string;
    formattedPrice: number;
    url: string;
    title: string;
  } | null = null;

  totalFormattedPrice: string | null = null;

  async created() {
    const product = await this.shopifyClient.getProduct(this.productHandle);
    product.formattedPrice = formatMoney(product.price);
    this.product = product;

    this.totalFormattedPrice = formatMoney(product.price * this.quantity);
  }
}
